import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ServiceCard } from '../components/ServiceCard';
import { CTASection } from '../components/CTASection';
import { services } from '../data/services';
export function Services() {
  return <>
      <PageHeader eyebrow="Fiduciary Services" title="Professional Fiduciary Services" description="Trust administration, estate administration, conservatorship support, personal fiduciary care and care management — handled professionally and discreetly." crumbs={[{
      label: 'Fiduciary Services'
    }]} data-id="element-334" data-mp="3ocnpqamlkt6x" />

      <section className="bg-white" data-id="element-335" data-mp="b4kmspqd0zsc">
        <div className="mx-auto max-w-content px-6 py-16 sm:py-20 lg:px-8" data-id="element-336" data-mp="b3j542eu9f1n">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-337" data-mp="65zpoz6emw84">
            {services.map(service => <ServiceCard key={service.slug} service={service} data-id="element-338" data-mp="2cvxtnkbw1hr1" />)}
          </div>
          <p className="mt-12 max-w-3xl border-l-2 border-gold-400 pl-5 text-[15px] leading-relaxed text-navy-600" data-id="element-339" data-mp="27xmhh2y4ev5n">
            Not sure which service applies to your situation? Contact us and we will
            help identify the type of fiduciary or administrative support that fits.
          </p>
        </div>
      </section>

      <CTASection title="Need Professional Fiduciary Support?" primaryLabel="Speak With Our Team" secondaryLabel="About Us" secondaryTo="/about" data-id="element-340" data-mp="1fnel0axwalsc" />
    </>;
}